/**
 * Ticket 114.3 — useDemoIndustries hook.
 *
 * Loads the industry catalog for a given country, resolved with the
 * current UI locale passed in. Refetches when country or locale changes.
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listDemoIndustries, type DemoIndustry } from '@/api/demos';

export function useDemoIndustries(country?: string) {
  const { i18n } = useTranslation();
  const locale = i18n.language ?? 'es';

  const [industries, setIndustries] = useState<DemoIndustry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    listDemoIndustries({ country: country ?? undefined, locale })
      .then(setIndustries)
      .catch(() => setError('demos.catalog.industries.loadError'))
      .finally(() => setLoading(false));
  }, [country, locale]);

  return { industries, loading, error };
}
